<script>
    import { onMount } from "svelte";
    import { showDebug } from "../stores.js";

    let pageName="About Page";

    /**
     * This is some debugging code to try and figure out a way to
     * let an overlay ignore a contextmenu event, but let it appear
     * on the background canvas instead.
     * So far, no luck. 
     */
    function overlayClicked(event) {
        event.preventDefault();
        console.log("OVERLAY CANVAS CLICKED");
    }

    function backgroundClicked(event) {
        console.log("BACKGROUND CANVAS CLICKED");
    }

    onMount(() => {

        if ($showDebug) {
            // Get the overlay canvas element
            var overlayCanvas = document.getElementById("overlayCanvas");
            var backgroundCanvas = document.getElementById("backgroundCanvas");

            // Prevent the context menu event on the overlay canvas
            overlayCanvas.addEventListener("contextmenu", function(event) {
                event.preventDefault();
                console.log("OVERLAY CANVAS CONTEXTMENU PRESSED");

                // Create a synthetic contextmenu MouseEvent
                let evt = new MouseEvent("contextmenu", {
                    bubbles: true,
                    cancelable: true,
                    view: window,
                });
                // Fire new contextmenu event on the background canvas
                backgroundCanvas.dispatchEvent(evt);
            });

            backgroundCanvas.addEventListener("contextmenu", function(event) {
                //event.preventDefault();
                console.log("BACKGROUND CANVAS CONTEXTMENU PRESSED");
            });

            if (backgroundCanvas.getContext) {
                const ctx = backgroundCanvas.getContext("2d");

                ctx.fillStyle = "rgb(200, 0, 0)";
                ctx.fillRect(10, 10, 50, 50);

                ctx.fillStyle = "rgba(0, 0, 200, 0.5)";
                ctx.fillRect(30, 30, 50, 50);
            }
        }
    });
</script>

<main>
    <h1> {pageName}!</h1>
    <p>Nothing to see here at <b>{pageName}</b> page</p>

    {#if $showDebug}
        <div id="canvasContainer">
            <canvas id="backgroundCanvas" width="400" height="300" on:click={backgroundClicked}></canvas>
            <canvas id="overlayCanvas" width="400" height="300" on:click={overlayClicked}></canvas>
        </div>
    {/if}
    
</main>

<style>
    main {
        text-align: center;
        padding: 1em;
        max-width: 240px;
        margin: 0 auto;
    }

    h1 {
        color: #ff3e00;
        text-transform: uppercase;
        font-size: 4em;
        font-weight: 100;
    }

    @media (min-width: 640px) {
        main {
            max-width: none;
        }
    }

    #canvasContainer {
      position: relative;
    }

    #overlayCanvas {
      position: absolute;
      top: 0;
      left: 0;
      pointer-events: none; /* Here, only none works to get contextmenu to appear on backgroundCanvas */
      z-index: 1;
      background-color: rgba(240, 248, 255, 0.6);
    }

    #backgroundCanvas {
      position: absolute;
      top: 0;
      left: 0;
      pointer-events: auto;
      z-index: 0;
      background-color: #ff3e00;
      background-image: url("/Exciscope_logo_vektor.svg");
    }

    canvas {
      border: 1px solid black;
    }
</style>